    import Api from '../api/api';
    import {getQueryStringValue, getCookie } from './cookies';
    import {browserHistory} from 'react-router';
    import {CURRENT_LOCATION, SHOW_SELECTED, LAT_LONG, FETCH_LOCATION, LOCATION_DENIED, LOAD_VENUE_LIST} from './actionConstants';
    import {getSportsName} from '../helperFunction/helper';



    export function dispatchAction(type, payload){
      return function(dispatch){
        dispatch({ type: type , payload: payload});
      }
    }



    export function findMyLocation(oldLatLng, sports, allsports){
      return function (dispatch) {

        dispatch(dispatchAction(FETCH_LOCATION , true ));
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition( (position) => {

            return Api.getAddress(position.coords.latitude, position.coords.longitude).then(response =>{
                 console.log("position", position.coords.latitude, position.coords.longitude);
              let parsedResult = JSON.parse(response.text);
              dispatch(dispatchAction(LAT_LONG ,[position.coords.latitude, position.coords.longitude]));
              getSubLocality(parsedResult.results, function(sublocality){
                dispatch(dispatchAction(CURRENT_LOCATION , sublocality ));
                dispatch(dispatchAction(SHOW_SELECTED, true ));
                dispatch(dispatchAction(FETCH_LOCATION , false ));
                dispatch(checkIfLocationChange(sublocality, position.coords.latitude, position.coords.longitude , oldLatLng, sports, allsports));
                saveCurrentLocation(sublocality, position.coords.latitude, position.coords.longitude);

              })

            }).catch(err => {
              dispatch(dispatchAction(FETCH_LOCATION , false ));
            });
          },function (error) {
            dispatch(dispatchAction(FETCH_LOCATION , false ));
            if (error.code == error.PERMISSION_DENIED)
            dispatch(dispatchAction(SHOW_SELECTED, true ));
            dispatch(dispatchAction(LOCATION_DENIED , true ));

          }, {timeout: 30000, enableHighAccuracy: true, maximumAge: 75000});
        }
      }
    }


    export function getVenuesByLocation(address, lat, lng, oldLatLng, sports, allsports){

      var addressLowercase = address.toLowerCase();
      return function (dispatch){
        dispatch(dispatchAction(LAT_LONG ,[lat, lng] ));
        dispatch(dispatchAction(CURRENT_LOCATION ,addressLowercase));
        dispatch(dispatchAction(SHOW_SELECTED, true ));
        dispatch(checkIfLocationChange(addressLowercase, lat, lng, oldLatLng, sports, allsports));
        saveCurrentLocation(addressLowercase, lat, lng);
      }
    }



    function getSubLocality(results , callback){
     console.log("results", results);
      var sublocality = "";
      results[0].address_components.some(result => {
        result.types.some(locality => {
          if(locality == "sublocality_level_1" || locality == "locality" ){
            sublocality = result.long_name;
            return true;
          }
        });

        if(sublocality){
          return true;
        }
      });
      callback(sublocality.toLowerCase());
    }



  function checkIfLocationChange(address, lat, lng, oldLatLng, sports, allSports){
        return function (dispatch){
        try{
          if(lat != oldLatLng[0] || lng != oldLatLng[1]){
            dispatch(dispatchAction( LOAD_VENUE_LIST, ""));
          }
        }catch(err){
        }
        var newAddress = address.split(" ").join("-").split(",")[0];
        var sportsName = getSportsName(allSports, sports);
        var sportsUrl = sportsName.length > 0 ? sportsName.join("-") : "all";
        browserHistory.push("/venues/"+newAddress+"/sports/"+sportsUrl.toLowerCase());
      }

    }


export function saveCurrentLocation(address, lat, lng){
  var body = {key : address.split(",")[0], lat : lat , lng : lng}

  return Api.saveLocation(body).then(response => {
    let parsedResult = JSON.parse(response.text);
    console.log(parsedResult.message);

  })

}



export function backToListing(address, sports, allSports){

  var newAddress = address.split(" ").join("-").split(",")[0];
  var sportsName = getSportsName(allSports, sports);
  var sportsUrl = sportsName.length > 0 ? sportsName.join("-") : "all";
  browserHistory.push("/venues/"+newAddress+"/sports/"+sportsUrl.toLowerCase());

}



// WEBPACK FOOTER //
// ./src/action/findLocation.js